import Vue from "vue/dist/vue.esm";
// 套件
import { ValidationProvider, ValidationObserver } from "vee-validate";
// store
import store from "./store";
// 其他元件
import SurveyForm from "./components/survey_form.vue";

// vue init
document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    el: "#vue-app",
    store,
    components: {
      SurveyForm,
    },
  });
});

// 套件使用
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
